// Currency Cache Hook - Uses cached currency data from database
import { useState, useEffect } from 'react';
import { currencyCacheService } from '../services/currencyCacheService';

export const useCurrencyCache = () => {
  const [currencies, setCurrencies] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCurrencies = async () => {
      try {
        setLoading(true);
        setError(null);
        const currencyData = await currencyCacheService.getCurrencies();
        setCurrencies(currencyData);
      } catch (err) {
        console.error('Error loading currencies:', err);
        setError(err.message);
        // Set fallback currencies
        setCurrencies({
          PKR: { symbol: '₨', code: 'PKR', country: 'Pakistan', decimals: 0 }
        });
      } finally {
        setLoading(false);
      }
    };

    loadCurrencies();
  }, []);

  // Format currency with cached data
  const formatCurrency = (amount, currency) => {
    return currencyCacheService.formatCurrency(amount, currency);
  };

  // Get currency symbol
  const getCurrencySymbol = (currency) => {
    return currencyCacheService.getCurrencySymbol(currency);
  };

  // Get currency decimals
  const getCurrencyDecimals = (currency) => {
    return currencyCacheService.getCurrencyDecimals(currency);
  };

  // Refresh currencies from database
  const refreshCurrencies = async () => {
    try {
      setLoading(true);
      currencyCacheService.clearCache();
      const currencyData = await currencyCacheService.getCurrencies();
      setCurrencies(currencyData);
    } catch (err) {
      console.error('Error refreshing currencies:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    currencies,
    loading,
    error,
    formatCurrency,
    getCurrencySymbol,
    getCurrencyDecimals,
    refreshCurrencies
  };
};

export default useCurrencyCache;
